const typography = {
  body1: {
    fontWeight: 500,
  },
  body2: {
    fontWeight: 500,
  },
  button: {
    fontWeight: 600,
  },
  caption: {
    fontWeight: 500,
  },
  h1: {
    fontWeight: 400,
  },
  h2: {
    fontWeight: 400,
  },
  h3: {
    fontWeight: 500,
  },
  h4: {
    fontWeight: 500,
  },
  h5: {
    fontWeight: 500,
  },
  h6: {
    fontWeight: 600,
  },
  overline: {
    fontWeight: 500,
    fontSize: '.68rem',
    lineHeight: 1.65,
  },
  subtitle1: {
    fontWeight: 500,
  },
  subtitle2: {
    fontWeight: 600,
  },
  fontWeightBold: 900,
  fontWeightLight: 400,
  fontWeightMedium: 600,
  fontWeightRegular: 500,
};

export default typography;
